module.exports = __webpack_public_path__ + "img/toprightlogo.a614d599.png";